import { Box as BoxComponent, SystemIcon } from "@justworkshr/milo-components";
import { useState } from "react";
import { DependentType, SingleDependentType } from "types";
import DeleteDependent from "../../pages/CensusAndCurrentInformation/components/CurrentEmployees/DeleteUpsellDependent";
import styles from "./EmployeeTableUpsell.module.css";

interface IDependentBoxProps {
  title: string;
  dependentDescription: DependentType;
  updateDependentList: (
    newDependent: SingleDependentType,
    method: "Delete" | "Add" | "Edit"
  ) => void;
}

const DependentBox = ({
  title,
  dependentDescription,
  updateDependentList,
}: IDependentBoxProps): JSX.Element => {
  const [toggleDescription, setToggleDescription] = useState(false);
  const iconName = toggleDescription ? "chevron-up" : "chevron-down";

  return (
    <div className={styles.dependentboxContainer}>
      <BoxComponent>
        <h3
          className={styles.boxHeader}
          data-testid="box-container-upsell"
          onClick={() => setToggleDescription(!toggleDescription)}
        >
          <SystemIcon
            iconName={iconName}
            color="neutral"
            title="arrow"
            size="medium"
            className={styles.icon}
          />
          <span>{title}</span>
        </h3>
        {toggleDescription && (
          <>
            {dependentDescription?.map((dependant, index) => (
              <DeleteDependent
                key={index}
                data={dependant}
                updateDependentList={updateDependentList}
              />
            ))}
          </>
        )}
      </BoxComponent>
    </div>
  );
};

export default DependentBox;
